// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes i2Q_wLuETkDnlZ {
  0% {
    width: 12px;
  }
  100% {
    width: 0px;
  }
}
.YXiuSwHORMBbQd {
  padding: var(--ds-space-0, 0);
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR {
  position: relative;
  width: 12px;
  height: 100%;
  background: transparent;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR::before,
.YXiuSwHORMBbQd .Aiirgv02yslqZR::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  transform: translateX(-1px);
  border-radius: 1px;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR::before {
  display: none;
  top: var(--ds-space-050, 4px);
  bottom: var(--ds-space-050, 4px);
  background-color: var(--ds-background-accent-blue-subtler-pressed, #579dff);
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR::after {
  display: block;
  top: 50%;
  height: var(--ds-space-250, 20px);
  margin-top: var(--ds-space-negative-150, -10px);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
@media (prefers-reduced-motion: reduce) {
  .YXiuSwHORMBbQd .Aiirgv02yslqZR {
    animation: unset;
  }
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2.UaIc21oqAqYOK7 {
  animation: 0.1s 0.2s forwards i2Q_wLuETkDnlZ;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2.t7eBHL4l0JboeJ {
  width: 0;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2:hover,
.YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2:focus {
  cursor: pointer;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2::after,
.YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2::before {
  width: 0;
}
@media (prefers-reduced-motion: reduce) {
  .YXiuSwHORMBbQd .Aiirgv02yslqZR.vpQR3toNmVMWo2 {
    width: 0;
  }
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR:hover,
.YXiuSwHORMBbQd .Aiirgv02yslqZR:focus,
.YXiuSwHORMBbQd .Aiirgv02yslqZR.eAdJyJJwbgvarV {
  cursor: ew-resize;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR:hover::after,
.YXiuSwHORMBbQd .Aiirgv02yslqZR:focus::after,
.YXiuSwHORMBbQd .Aiirgv02yslqZR.eAdJyJJwbgvarV::after {
  display: none;
}
.YXiuSwHORMBbQd .Aiirgv02yslqZR:hover::before,
.YXiuSwHORMBbQd .Aiirgv02yslqZR:focus::before,
.YXiuSwHORMBbQd .Aiirgv02yslqZR.eAdJyJJwbgvarV::before {
  display: block;
}
`, ""]);
// Exports
export var dragAndDropDividerContainer = `YXiuSwHORMBbQd`;
export var dragAndDropDivider = `Aiirgv02yslqZR`;
export var hidden = `vpQR3toNmVMWo2`;
export var animate = `UaIc21oqAqYOK7`;
export var dividerAnim = `i2Q_wLuETkDnlZ`;
export var noAnimation = `t7eBHL4l0JboeJ`;
export var dragging = `eAdJyJJwbgvarV`;
export default ___CSS_LOADER_EXPORT___;
